const ALLERGENS_LIST = [
  'gluten',
  'glutenowy',
  'bezglutenowy',
  'zboża',
  'zboże',
  'pszenica',
  'pszenicę',
  'pszenny',
  'pszenna',
  'z pszenicy',
  'pszenicy',
  'pszenicą',
  'pszenne',
  'żyto',
  'żytni',
  'żytnie',
  'z żyta',
  'żyta',
  'żytnia',
  'jęczmień',
  'jęczmienny',
  'jęczmienna',
  'owies',
  'owsiane',
  'owsiana',
  'owsa',
  'orkisz',
  'orkiszowe',
  'orkiszowa',
  'kamut',
  'skorupiaki',
  'skorupiaków',
  'krab',
  'kraby',
  'kraba',
  'homar',
  'homary',
  'homara',
  'krewetki',
  'krewetka',
  'jaja',
  'jaj',
  'jajek',
  'jajka',
  'ryby',
  'ryb',
  'rybny',
  'rybę',
  'łosoś',
  'Losos',
  'łososia',
  'tuńczyk',
  'tuńczyka',
  'czarniak',
  'czarniaka',
  'żabnica',
  'żabnicę',
  'pstrąg',
  'Pstrag',
  'pstrąga',
  'makrela',
  'makrelę',
  'śledź',
  'śledzie',
  'śledziowy',
  'śledzia',
  'sardynki',
  'dorsz',
  'dorsza',
  'sandacz',
  'soja',
  'soje',
  'soję',
  'sojowa',
  'sojowy',
  'soją',
  'sojowe',
  'z soi',
  'soi',
  'mleko',
  'z mleka',
  'mleka',
  'śmietana',
  'śmietanę',
  'śmietanka',
  'śmietankę',
  'masło',
  'masłem',
  'laktoza',
  'laktozę',
  'laktozą',
  'orzeszki ziemne',
  'orzechy ziemne',
  'orzeszki ziemne (arachidowe)',
  'orzechy arachidowe',
  'orzeszki arachidowe',
  'migdały',
  'orzechy laskowe',
  'orzeszki laskowe',
  'orzechy włoskie',
  'orzeszki włoskie',
  'orzechy nerkowca',
  'orzeszki nerkowca',
  'orzeszki pekan',
  'orzechy pekan',
  'orzechy brazylijskie',
  'orzeszki brazylijskie',
  'pistacje',
  'orzechy pistacjowe',
  'orzeszki pistacjowe',
  'orzechy makadamia',
  'orzeszki makadamia',
  'orzechy macadamia',
  'orzeszki macadamia',
  'orzeszki sojowe',
  'orzechy sojowe',
  'orzeszki piniowe',
  'orzechy piniowe',
  'orzechy Queensland',
  'orzechy queensland',
  'orzeszki Queensland',
  'orzechy',
  'orzeszki',
  'kasza manna',
  'kaszę mannę',
  'seler',
  'selera',
  'gorczycy',
  'gorczyca',
  'gorczycę',
  'sezam',
  'sezamowy',
  'sezamu',
  'dwutlenek siarki',
  'Siarczyny',
  'So2',
  'łubin',
  'anchois',
  'ikra gromadnika',
  'ikrę gromadnika',
  'ikra śledzia',
  'ikrę śledzia',
  'mięczaki',
  'mięczaków',
  'małże',
  'kalmary',
  'ślimaki',
  'ostrygi',
  'ośmiornice',
  'trąbiki',
  'omułki',
  'sezamowa',
  'sezamowego',
  'jęczmienne',
  'sezamowe',
  'ikra ryb',
  'sojowego',
  'ryba',
  'śledziowe',
  'glutenu',
  'orzechów',
  'orzeszków ziemnych',
  'alergeny'
]

const escapeRegExp = (str: string) => {
  return str.replace(/[.*+?^${}()|[\]\\]/g, '\\$&')
}

export const boldAllergensInString = (text: string): string => {
  // Input validation
  if (!text || typeof text !== 'string') {
    return text || ''
  }

  // Early return for empty strings
  if (text.trim() === '') {
    return text
  }

  let result = text

  // Check if text contains HTML-like structure
  const isHTML = /<[^>]+>/.test(text)

  ALLERGENS_LIST.forEach(allergen => {
    const escapedAllergen = escapeRegExp(allergen)

    const regex = isHTML
      ? new RegExp(`(>)([^<]*?)${escapedAllergen}([^>]*?)(<)`, 'giu')
      : new RegExp(`\\b${escapedAllergen.replace(/\s+/g, '\\s+')}\\b`, 'giu')

    result = result.replace(regex, (match: string, ...args: string[]) => {
      if (isHTML && args.length >= 4) {
        const [start, before, after, end] = args as [
          string,
          string,
          string,
          string
        ]

        const fullContext = `${before}${allergen}${after}`

        if (fullContext.includes('<b>') && fullContext.includes('</b>')) {
          return match
        }

        return `${start}${before}<b>${allergen}</b>${after}${end}`
      }

      if (isHTML && args.length < 4) {
        if (match.includes('<b>') && match.includes('</b>')) {
          return match
        }

        return `<b>${allergen}</b>`
      }

      if (!isHTML) {
        if (match.includes('<b>') && match.includes('</b>')) {
          return match
        }

        return `<b>${match}</b>`
      }

      return match
    })
  })

  result = result.replace(/<b>(<b>.*?<\/b>)<\/b>/g, '$1')

  return result
}
